
const isEmpty = {
    // created: function () {
        // this.hello()
    // },
    methods: {
        isEmpty: function (someObject) {
            return (someObject === undefined || someObject === null || Object.keys(someObject).length === 0);
        }
    }
};

export default isEmpty;